/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Youtube_Export_UploadInputs */

const cs_youtube_export_upload = /** @type {(inputs: Youtube_Export_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nahrát na YouTube`)
};

const en_youtube_export_upload = /** @type {(inputs: Youtube_Export_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload to YouTube`)
};

/**
* | output |
* | --- |
* | "Upload to YouTube" |
*
* @param {Youtube_Export_UploadInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const youtube_export_upload = /** @type {((inputs?: Youtube_Export_UploadInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Youtube_Export_UploadInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_youtube_export_upload(inputs)
	return cs_youtube_export_upload(inputs)
});